var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container"},[_c('div',{staticClass:"main-container"},[_c('router-view')],1),_c('div',{attrs:{"id":"question-options-width"}})])}
var staticRenderFns = []

export { render, staticRenderFns }